var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("hr", {
    staticClass: "jade-divider",
    class: _vm.computedClassList,
    attrs: { role: "separator" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }